import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  error: {
    height: "50vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    color: "red",
  },
  errorBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    border: [1, "solid", "red"],
    padding: 20,
    borderRadius: 5,
    textAlign: "center",
  },
  errorText: {
    marginTop: 20,
  },
});

const ErrorBox = ({ error, children }) => {
  const styles = useStyles();

  return (
    <div className={styles.error}>
      <div className={styles.errorBox}>
        <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
        <div className={styles.errorText}>{error}</div>
        {children}
      </div>
    </div>
  );
};

export { ErrorBox };
